export default __webpack_public_path__ + "d4b0beab20c8b83c47d333548870236e.png";